/* eslint-disable */
import React, { useState, useEffect, useContext, useRef} from "react"
import { Modal, Button } from "@4cplatform/elements/Molecules"
import { usePost, ApiError } from "@4cplatform/elements/Api"
import { ConfigContext } from "@4cplatform/elements/Config"

const TermsConditionsOverlay = () => {
  const [showOverlay, setShowOverlay] = useState(false)
  const { TERMS_LAST_UPDATED } = useContext(ConfigContext)
  const [checkLatestAction, { data: latestTermsAcceptance, loading }] = usePost({
    endpoint: "/users/latest-action",
    body: { action: "accepted_terms_and_conditions" }
  })

  const shouldPop = useRef(false)

  const [acceptTerms, { loading: acceptTermsLoading, error: acceptTermsError }] = usePost({
    endpoint: "/users/accept-terms-and-conditions",
    onCompleted: () => {
      setShowOverlay(false)
    },
    onError: (error) => {
      console.error("Error accepting terms:", error instanceof ApiError ? error.message : error)
    }
  })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    checkLatestAction()
  }, [])

  useEffect(() => {
    // Only check if the API call has completed due to re-rendering mess.
    if (!loading) {
      const termsLastUpdated = new Date(TERMS_LAST_UPDATED)

      setShowOverlay(false)

      // Show the overlay if:
      // 1. latestTermsAcceptance is undefined or null (4c-api returned no result)
      // 2. latestTermsAcceptance has a created_at timestamp that's older than the last terms update timestamp
      if (latestTermsAcceptance === undefined || latestTermsAcceptance === null) {
        // 4c-api returned no result, show the overlay
        setShowOverlay(true)
      } else if (latestTermsAcceptance.created_at) {
        // Accept exists, check if the acceptance is older than the last update
        const lastAcceptedDate = new Date(latestTermsAcceptance.created_at)
        if (lastAcceptedDate < termsLastUpdated) {
          // Acceptance is older than the last update, show the overlay
          setShowOverlay(true)
        }
      }
    }
  }, [latestTermsAcceptance, loading])

  const handleClose = () => {
    acceptTerms()
    setShowOverlay(false)
  }

  // Don't show the overlay while loading - important because of the re-re-re-rendering
  if (loading || !showOverlay) return null

  return (
    <Modal
      onClose={handleClose}
      name="terms_conditions_overlay"
      title="Updated Terms & Conditions"
      hasHeader
      aria-label="Terms and Conditions Notification"
    >
      <div style={{ padding: "10px 20px 20px" }}>
        <p>
          We've made some updates to our Terms &amp; Conditions, effective {new Date(TERMS_LAST_UPDATED).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}.
        </p>
        <p>You can review the updated Terms &amp; Conditions by clicking the button below.</p>
        <p style={{ display: "block", margin: "0 0 30px" }}>
          By continuing to use our services after {new Date(TERMS_LAST_UPDATED).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}, you agree to the updated Terms.
        </p>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
          <Button
            name="view_terms"
            appearance="primary"
            aria-label="View Terms and Conditions"
            onClick={() => {
              window.open("/terms-conditions", "_blank")
              acceptTerms()
            }}
          >
            View Terms & Conditions
          </Button>
          <Button
            name="close_overlay"
            appearance="secondary"
            aria-label="Close Terms and Conditions Notification"
            onClick={handleClose}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default TermsConditionsOverlay
